export interface StripeProduct {
  priceId: string;
  name: string;
  description: string;
  price: number;
  currency: string;
  mode: 'subscription' | 'payment';
}

export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    priceId: 'price_1RLtZjDOHKOrOESFrub7NTzG',
    name: 'EventPour',
    description: 'A EventPour é a ferramenta definitiva para bartenders, organizadores de eventos e empresários do setor de bebidas que buscam eliminar o estresse de orçamentos imprecisos e compras mal dimensionadas.',
    price: 1.00,
    currency: 'R$',
    mode: 'subscription'
  }
];

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return STRIPE_PRODUCTS.find(product => product.priceId === priceId);
};